/* eslint-disable no-useless-escape */
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useForm, Controller, useWatch } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import Select from 'react-select';
import { useLocation } from 'react-router-dom';
import {
  BsFillImageFill,
  BsCameraVideoFill,
  BsChatDotsFill
} from 'react-icons/bs';
import { AiFillFilePdf } from 'react-icons/ai';
import {
  Container,
  Row,
  Card,
  Form,
  Col,
  Input,
  CardHeader,
  CardBody
} from 'reactstrap';

import SimpleHeader from 'components/Headers/SimpleHeader.js';
import ReactLoader from 'components/Loader';
import ReactButton from 'components/Buttons/ReactButton';
import FlexSelect from 'components/Inputs/FlexSelect';
import QueueService from 'views/Queue/service';
import { custom_select } from 'assets/styles/multiple_select';
import {
  templateParamsRegex,
  broadcastTypeOfClosingConversationOptions,
  TYPES_BROADCAST_LIST
} from '../utils';
import DatePicker from 'components/Inputs/DatePicker';

import TemplateMessageFilling from './components/TemplateMessageFillingList';
import { SelectTemplateWrapper, SelectTemplateOptions } from './styled';
import { ErrorFormMessage } from 'components/ErrorFormMessage';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { customFieldTypes } from 'views/fieldConfigs/utils/customFieldTypes';
import FlexChatIntegration from 'views/ServicePanel/components/QueueContent/components/Contact/service/FlexChatIntegration';
import { ScreenPrompt } from 'components/ScreenPrompt';
import { SearchTemplateWhatsapp } from 'views/ServicePanel/components/QueueContent/components/Contact/Function';
import { CreatableFlexSelect } from '../../../components/Inputs/CreatableSelect';
import ChatBroadcastListService from 'views/ChatBroadcastList/service';
import { ProtocolFieldsBroadcastList } from './components/ProtocoloFields/ProtocolFieldsBrosdcastList';
import FlexIAService from '../../FlexIA/service';
import getFlexIAType from 'views/FlexIA/utils/getFlexIAType';
import { FlexController } from 'components/FlexControllerInput';
import BroadcastSchedulingFields from 'components/BroadcastSchedulingFields';
import { DatesHelper } from 'utils/classes/DatesHelper';
import { handleFilterFlexiaByType } from 'utils/fuctions/handleFilterFlexiaByType';
import { useRecordTypesByUser } from 'views/RecordType/hooks/useRecordTypesByUser';

const TagConversaField = ({
  tagConversa,
  setTagConversa,
  control,
  setValue,
  errors,
  label = ''
}) => {
  return (
    <Col md="6" className="mb-3">
      <label className="form-control-label">{label}</label>
      <Controller
        render={() => (
          <CreatableFlexSelect
            isClearable
            placeholder={'Adicionar...'}
            controlStyle={{ minHeight: '46px' }}
            setValue={setTagConversa}
            valueController={setValue}
            defaultValue={tagConversa}
            value={tagConversa}
          />
        )}
        control={control}
        name="tagConversa"
        defaultValue={[]}
      />
      <ErrorMessage
        errors={errors}
        name="tagConversa"
        render={({ message }) => <p style={{ color: 'red' }}>{message}</p>}
      />
    </Col>
  );
};

export const ChatBroadcastListForm = (props) => {
  const {
    TRANSFER_TO_FLEXIA_WITH_PROTOCOL,
    TRANSFER_TO_FLEXIA,
    CLOSE_ON_FIRST_RESPONSE,
    TRANSFER_TO_QUEUE,
    CLOSE_AFTER_SEND,
    TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE
  } = TYPES_BROADCAST_LIST;

  const { id } = props.match.params;
  const history = useHistory();
  const {
    reset,
    control,
    handleSubmit,
    errors,
    setValue,
    setError,
    clearErrors,
    getValues,
    watch,
    formState
  } = useForm();
  const { isDirty } = formState;
  const location = useLocation();
  const dataContacts = location.state;
  const { contacts } = location.state || {};

  const [isUpdate, setIsUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  /**
   * Determina se o campo de habilitar agendamento está marcado ou não.
   * @type {[boolean, React.Dispatch<React.SetStateAction<boolean>>]}
   */
  const [isEnabledSchedule, setIsEnabledSchedule] = useState(false);
  const [queues, setQueues] = useState(null);
  const [tagConversa, setTagConversa] = useState([]);

  // eslint-disable-next-line no-unused-vars
  const [templates, setTemplates] = useState(null);
  const [templatesTitle, setTemplatesTitle] = useState(null);

  const [selectedTemplate, setSelectedTemplate] = useState(null);

  const [templateParams, setTemplateParams] = useState({});
  const [clientFields, setClientFields] = useState([]);
  const [files, setFiles] = useState([]);

  const [recordTypesProtocol, setRecordTypesProtocol] = useState([]);
  const [selectedFlexia, setSelectedFlexia] = useState(undefined);

  const selectedOption = watch('broadcastTypeOfClosingConversation');
  const selectedRecordType = watch('recordTypeId');

  const [templatePlaceholders, setTemplatePlaceholders] = useState([]);

  const defaultContactRecordType = 301;
  const { customFields, getCustomFields, isLoadingCustomFields } =
    useEntityCustomFieldsByRecordType(
      entitiesName.CONTACT,
      defaultContactRecordType
    );
  const {
    recordTypes: leadRecordTypes,
    isLoadingRecordTypes: isLoadingLeadRecordTypes,
    getRecordTypesByUser: getLeadRecordTypes
  } = useRecordTypesByUser(entitiesName.LEAD);
  const {
    recordTypes: opportunityRecordTypes,
    isLoadingRecordTypes: isLoadingOpportunityRecordTypes,
    getRecordTypesByUser: getOpportunityRecordTypes
  } = useRecordTypesByUser(entitiesName.OPPORTUNITY);
  const [flexiaData, setFlexiaData] = useState([]);
  const [flexiaDataAll, setFlexiaDataAll] = useState([]);
  const [whatsappList, setWhatsappList] = useState([]);
  const whatsappOptions = whatsappList.map((item) => {
    return { value: item.source, label: item.nome_canal };
  });

  const whatsapp = useWatch({
    name: 'sourcePhone',
    control
  });
  const watchCreateLead = watch('createLead');
  const watchCreateOpportunity = watch('createOpportunityOnFirstResponse');

  // Validação unificada para renderizar tags de contexto e Watson
  const shouldRenderFlexiaTags = useMemo(
    () =>
      selectedOption === TYPES_BROADCAST_LIST.TRANSFER_TO_FLEXIA ||
      selectedOption ===
        TYPES_BROADCAST_LIST.TRANSFER_TO_FLEXIA_WITH_PROTOCOL ||
      Boolean(
        flexiaData.find(
          (flexia) => flexia.type === 'WATSON' && flexia.id === selectedFlexia
        ) !== undefined
      ),
    [selectedOption, flexiaData, selectedFlexia]
  );

  const _getTemplates = (telefone) => {
    FlexChatIntegration.getContatoAtivoByPhone(telefone)
      .then((res) => {
        const templatesData = res?.data?.data ?? [];
        const templatesDTO = templatesData.map(({ id, description, type }) => ({
          label: description,
          value: id,
          templateType: type
        }));

        setTemplates(templatesDTO);
      })
      .catch(() => toast.error('Erro ao buscar templates'));
  };

  const _getTemplatesTitle = (telefone) => {
    FlexChatIntegration.getContatoAtivoByPhone(telefone)
      .then((res) => {
        const templatesTitleData = res?.data?.data ?? [];
        const templatesTitleDTO = templatesTitleData.map(
          ({ id, description, type, name }) => ({
            label: description,
            value: id,
            templateType: type,
            name: name
          })
        );
        setTemplatesTitle(templatesTitleDTO);
      })
      .catch(() => toast.error('Erro ao buscar templates'));
  };

  useEffect(() => {
    if (!whatsapp) return;
    _getTemplates(whatsapp);
    _getTemplatesTitle(whatsapp);
  }, [whatsapp]);

  const Icons = {
    IMAGE: <BsFillImageFill />,
    VIDEO: <BsCameraVideoFill />,
    DOCUMENT: <AiFillFilePdf />,
    TEXT: <BsChatDotsFill />
  };

  const Colors = {
    DOCUMENT: '#d92222d1',
    IMAGE: '#2dce89',
    VIDEO: '#11cdef',
    TEXT: 'rgb(54 54 96)'
  };

  const currentDate = () => {
    const currentDate = new Date();
    const day = currentDate.getDate().toString().padStart(2, '0');
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const year = currentDate.getFullYear().toString();
    return `${day}/${month}/${year}`;
  };

  const getWhatsapp = () => {
    FlexChatIntegration.getWhatsapp()
      .then((res) => {
        setWhatsappList(res?.data?.data ?? []);
      })
      .catch(() => {
        toast.error('Erro ao buscar whatsapp');
      });
  };

  const getQueues = useCallback(async () => {
    QueueService.getAll()
      .then((response) => {
        const queuesData = response.data.data;
        if (queuesData) {
          const queuesDTO = queuesData.map(({ id, name }) => ({ id, name }));
          setQueues(queuesDTO);
        }
      })
      .catch(() => {
        toast('Ocorreu um erro ao carregar as filas');
      });
  }, []);

  const getClientFields = useCallback(() => {
    if (isLoadingCustomFields) return;
    const defaultFields = [
      { label: 'Nome', value: 'nome' },
      { label: 'Telefone', value: 'telefone' }
    ];
    const customizedFields = customFields
      .filter((field) => field.type === customFieldTypes.TEXT)
      .map((field) => ({
        label: field.label,
        value: field.name
      }));

    setClientFields(defaultFields.concat(customizedFields || []));
  }, [customFields, isLoadingCustomFields]);

  const getExpirationDate = (data) => {
    if (!data) {
      return {};
    }
    let info = new Date(data);
    const horas = info.toLocaleTimeString();
    const novaData = info.toLocaleDateString('pt-BR');
    return {
      expiryDay: novaData,
      expirationTime: horas
    };
  };

  const getBroadcastListToEdit = (broadcastListId) => {
    setLoading(true);

    FlexChatIntegration.getBroadcastListById(broadcastListId)
      .then(async (response) => {
        const broadcastListData = response.data.data;

        const res = await FlexChatIntegration.getContatoAtivoByPhone(
          broadcastListData.sourcePhone
        );

        const templatesData = res?.data?.data ?? [];
        const templatesDTO = templatesData.map(
          ({ id, description, type, name, media }) => ({
            label: description,
            value: id,
            templateType: type,
            name: name,
            media: media
          })
        );
        setTemplates(templatesDTO);

        const label = templatesDTO.find(
          (t) => t.value === broadcastListData.whatsappTemplateId
        )?.label;

        const name = templatesDTO.find(
          (t) => t.value === broadcastListData.whatsappTemplateId
        )?.name;

        setSelectedTemplate({
          label: label,
          value: broadcastListData.whatsappTemplateId,
          templateType: broadcastListData.templateType,
          url: broadcastListData.url,
          data: broadcastListData.message,
          name: name,
          media: broadcastListData.media
        });

        let resetFieldsProtocol = {};
        if (
          broadcastListData.typeBroadcastList ===
          TRANSFER_TO_FLEXIA_WITH_PROTOCOL
        ) {
          resetFieldsProtocol = {
            recordTypeId: broadcastListData.recordTypeId
          };

          if (broadcastListData.protocolParams) {
            broadcastListData.protocolParams.forEach((param) => {
              resetFieldsProtocol[`protocol.${param.protocol_column}.label`] =
                param.protocol_column;
              resetFieldsProtocol[`protocol.${param.protocol_column}.value`] =
                param.value;
              resetFieldsProtocol[`protocol.${param.protocol_column}.type`] =
                param.type;
            });
          }
        }
        setSelectedFlexia(broadcastListData.flexiaId);
        setIsEnabledSchedule(broadcastListData.isEnabledSchedule ?? false);

        {
          let [year, month, day] = String(broadcastListData.sendingScheduleDate)
            .split('T')[0]
            .split('-');
          broadcastListData.sendingScheduleDate =
            broadcastListData.sendingScheduleDate
              ? `${day}/${month}/${year}`
              : DatesHelper.getTodayInBrazilianFormat();
          broadcastListData.sendingScheduleTime =
            broadcastListData.sendingScheduleTime ?? '00:00:00';
        }

        const tagsFromData = broadcastListData.tagConversa
          ? broadcastListData.tagConversa.split(',')
          : [];

        setTagConversa(tagsFromData);

        reset({
          ...broadcastListData,
          sourcePhone: broadcastListData.sourcePhone,
          tagConversa: tagsFromData,
          title: broadcastListData.title,
          flexiaId: broadcastListData.flexiaId,
          queueId: broadcastListData.queue_id,
          broadcastTypeOfClosingConversation:
            broadcastListData.typeBroadcastList,
          closingMessage: broadcastListData.closingMessage ?? '',
          ...getExpirationDate(broadcastListData.expiresIn),
          ...resetFieldsProtocol
        });

        const raw = broadcastListData.message;
        const matches = Array.from(raw.matchAll(/{{\d+}}/g));
        const renumbered = matches.map((_, i) => `{{${i + 1}}}`);
        setTemplatePlaceholders(renumbered);

        const initialParams = {};
        renumbered.forEach((ph, idx) => {
          const savedParam = broadcastListData.params[idx];
          initialParams[ph] = {
            type: savedParam?.type || 'TEXT',
            value: savedParam?.value || ''
          };
        });
        setTemplateParams(initialParams);

        setIsUpdate(true);
      })
      .catch((err) => {
        const msg = err?.response?.data?.message;
        toast.error(msg || 'Erro ao buscar campanha', {
          autoClose: 3000,
          closeOnClick: true
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    FlexIAService.getAllFlexia(1, 100, '', { showDisable: false })
      .then((response) => {
        setFlexiaDataAll(response.data.result);
        setFlexiaData(
          response.data.result.map((flexia) => {
            return {
              ...flexia,
              optionSubtitle: getFlexIAType(flexia.type || '')
            };
          })
        );
      })
      .catch((err) => {
        toast.error(
          (err.response && err.response.data.message) ||
            'Erro ao listar configurações da FlexIA!',
          {
            autoClose: 3000,
            closeOnClick: true
          }
        );
      });
  }, []);

  useEffect(() => {
    getQueues();
  }, [getQueues]);

  useEffect(() => {
    getWhatsapp();
  }, []);

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  useEffect(() => {
    if (watchCreateLead) {
      getLeadRecordTypes();
    } else {
      setValue('leadRecordTypeId', '');
    }
  }, [watchCreateLead, getLeadRecordTypes, setValue]);

  useEffect(() => {
    if (watchCreateOpportunity) {
      getOpportunityRecordTypes();
    } else {
      setValue('opportunityRecordTypeId', '');
    }
  }, [watchCreateOpportunity, getOpportunityRecordTypes, setValue]);

  useEffect(() => {
    getClientFields();
  }, [getClientFields]);

  useEffect(() => {
    if (id) getBroadcastListToEdit(id);
  }, [id]);

  useEffect(() => {
    validateTemplateParams();
  }, [templateParams, validateTemplateParams]);

  useEffect(() => {
    if (selectedOption === TRANSFER_TO_FLEXIA_WITH_PROTOCOL) {
      getRecordTypesProtocol();
    }
  }, [selectedOption]);

  const getRecordTypesProtocol = async () => {
    const response = await ChatBroadcastListService.getRecordTypesProtocol();
    setRecordTypesProtocol(response?.length ? response : []);
  };

  const hourRules = {
    required: 'Hora é obrigatório!',
    pattern: {
      value: /^[0-2][0-9]:[0-5][0-9]:[0-5][0-9]$/,
      message: 'Hora inválida! (00:00:00)'
    }
  };

  const validateTemplateMessage = () => {
    if (!selectedTemplate) {
      setError('whatsappTemplateId', {
        type: 'required',
        message: 'Campo obrigatório'
      });
      return false;
    }
    return true;
  };

  function formatDate(dateString) {
    const [day, month, year] = dateString.split('/');
    return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
  }

  const validateTemplateParams = useCallback(() => {
    if (!selectedTemplate) return;
    const message = selectedTemplate.data;
    const paramsKeys = message.match(templateParamsRegex);
    if (!paramsKeys) return true;

    for (const key of paramsKeys) {
      if (!templateParams[key]?.type || !templateParams[key]?.value) {
        setError('whatsappTemplateParams', {
          type: 'required',
          message: 'Preencha todos os campos da mensagem predefinida'
        });
        return false;
      }
    }
    clearErrors('whatsappTemplateParams');

    return true;
  }, [clearErrors, setError, selectedTemplate, templateParams]);

  const onSubmit = async (data) => {
    if (data.expiryDay) {
      data.expiryDay = formatDate(data.expiryDay);
    }

    if (data.sendingScheduleDate) {
      data.sendingScheduleDate = formatDate(data.sendingScheduleDate);
    }

    const isTemplateValid = validateTemplateMessage();
    if (!isTemplateValid) return;

    const isParamsValid = validateTemplateParams();
    if (!isParamsValid) return;

    if (data.createLead && !data.leadRecordTypeId) {
      toast.error('Selecione o tipo de registro para Lead');
      return;
    }

    if (
      data.createOpportunityOnFirstResponse &&
      !data.opportunityRecordTypeId
    ) {
      toast.error('Selecione o tipo de registro para Oportunidade');
      return;
    }

    try {
      let broadcastListId;

      if (selectedTemplate.templateType === 'TEXT') {
        const requestBodyDTO = {
          ...data,
          userLogin: localStorage.getItem('login'),
          message: selectedTemplate.data,
          whatsappTemplateId: selectedTemplate.value,
          tagConversa: tagConversa,
          templateParams: templatePlaceholders.map((placeholder) => ({
            ...templateParams[placeholder]
          })),
          templateType: selectedTemplate.templateType,
          protocolParams: Object.keys(data?.protocol || {}).map(
            (fieldName) => ({
              type: data?.protocol[fieldName].type,
              protocol_column: fieldName,
              value: data?.protocol[fieldName].value
            })
          )
        };

        if (data.createLead) {
          requestBodyDTO.createLead = true;
          requestBodyDTO.leadRecordTypeId = data.leadRecordTypeId;
        }

        if (data.createOpportunityOnFirstResponse) {
          requestBodyDTO.createOpportunityOnFirstResponse = true;
          requestBodyDTO.opportunityRecordTypeId = data.opportunityRecordTypeId;
        }

        delete requestBodyDTO.protocol;

        if (isUpdate) {
          await FlexChatIntegration.putBroadcastList(id, requestBodyDTO);
          broadcastListId = id;
        } else {
          const response = await FlexChatIntegration.postBroadcastList(
            requestBodyDTO
          );
          broadcastListId = response.data.id;

          if (!broadcastListId) {
            throw new Error('Não foi possível obter o ID da campanha');
          }
        }
      } else {
        const hasFile = files.length > 0;

        if (!hasFile && !selectedTemplate.url && !selectedTemplate.media) {
          toast.error('O arquivo é obrigatório');
          return;
        }

        const formatedData = new FormData();

        formatedData.append('sourcePhone', data.sourcePhone);
        formatedData.append('createdBy', localStorage.getItem('login'));
        if (
          data.broadcastTypeOfClosingConversation === TRANSFER_TO_FLEXIA ||
          data.broadcastTypeOfClosingConversation ===
            TRANSFER_TO_FLEXIA_WITH_PROTOCOL
        ) {
          formatedData.append('flexiaId', data?.flexiaId);
        }

        if (hasFile) {
          formatedData.append('file', files[0]);
        } else if (selectedTemplate.media || selectedTemplate.url) {
          formatedData.append(
            'url',
            selectedTemplate.media || selectedTemplate.url
          );
        } else {
          toast.error('Nenhuma mídia disponível para envio.');
          return;
        }

        if (selectedTemplate.templateType === 'IMAGE') {
          formatedData.append('response_type', 'image');
          formatedData.append('type', 'image');
        } else if (selectedTemplate.templateType === 'VIDEO') {
          formatedData.append('response_type', 'video');
          formatedData.append('type', 'video');
        } else if (selectedTemplate.templateType === 'DOCUMENT') {
          formatedData.append('response_type', 'file');
          formatedData.append('type', 'file');
        }
        if (data.expiryDay) {
          formatedData.append('expiryDay', data.expiryDay);
        }
        if (data.expirationTime) {
          formatedData.append('expirationTime', data.expirationTime);
        }
        if (data.closingMessage) {
          formatedData.append('closingMessage', data.closingMessage);
        }
        formatedData.append('isEnabledSchedule', data.isEnabledSchedule);

        if (data.isEnabledSchedule) {
          formatedData.append('sendingScheduleDate', data.sendingScheduleDate);
          formatedData.append('sendingScheduleTime', data.sendingScheduleTime);
        }

        const message = selectedTemplate.data;
        const whatsappTemplateId = selectedTemplate.value;
        formatedData.append(
          'broadcastTypeOfClosingConversation',
          String(data.broadcastTypeOfClosingConversation)
        );

        formatedData.append('message', message);
        formatedData.append('whatsappTemplateId', whatsappTemplateId);
        formatedData.append('queueId', data.queueId);
        formatedData.append('title', data.title);
        formatedData.append('templateType', selectedTemplate.templateType);
        formatedData.append('watsonId', data.watsonId);

        formatedData.append('tagConversa', JSON.stringify(tagConversa));

        if (data.createLead) {
          formatedData.append('createLead', true);
          formatedData.append('leadRecordTypeId', data.leadRecordTypeId);
        }

        if (data.createOpportunityOnFirstResponse) {
          formatedData.append('createOpportunityOnFirstResponse', true);
          formatedData.append(
            'opportunityRecordTypeId',
            data.opportunityRecordTypeId
          );
        }

        /**
         * @typedef {Object} TemplateParamDTO
         * @property {string} type
         *   Tipo de preenchimento para envio ao backend (pode ser 'TEXT' ou outro tipo válido).
         * @property {string} value
         *   Valor associado ao placeholder (vazio se não houver valor específico em templateParams).
         */

        /**
         * Converte o array de placeholders em um array de DTOs prontos para envio
         * @type {TemplateParamDTO[]}
         */
        const templateParamsDTO = templatePlaceholders.map((placeholder) => ({
          type: templateParams[placeholder]?.type || 'TEXT',
          value: templateParams[placeholder]?.value || ''
        }));

        formatedData.append(
          'templateParams',
          JSON.stringify(templateParamsDTO)
        );
        formatedData.append('recordTypeId', data.recordTypeId);
        formatedData.append(
          'protocolParams',
          JSON.stringify(
            Object.keys(data?.protocol || {}).map((fieldName) => ({
              type: data?.protocol[fieldName].type,
              protocol_column: fieldName,
              value: data?.protocol[fieldName].value
            }))
          )
        );

        let res;
        if (isUpdate) {
          res = await FlexChatIntegration.updateBroadcastWithMidia(
            formatedData,
            id
          );
          broadcastListId = id;
        } else {
          res = await FlexChatIntegration.createBroadcastWithMidia(
            formatedData
          );
          broadcastListId = res.data.id;

          if (!broadcastListId) {
            throw new Error('Não foi possível obter o ID da campanha');
          }
        }

        if (res.status !== 200 && res.status !== 201) {
          const errorMessage = res.response.data.message;
          toast.error(errorMessage ?? 'Erro ao criar campanha');
          return;
        }
      }

      if (dataContacts?.contacts?.length > 0) {
        try {
          await ChatBroadcastListService.addContactsToBroadcastList(
            broadcastListId,
            contacts.map((contact) => ({
              id: contact.id,
              name: contact.name
            }))
          );
          toast.success('Contatos adicionados com sucesso à campanha');
        } catch (contactError) {
          console.error('Erro ao adicionar contatos à campanha:', contactError);
          toast.warning(
            'Campanha criada, mas houve um erro ao adicionar os contatos'
          );
        }
      } else {
        const action = id ? 'atualizada' : 'criada';
        toast.info(`Campanha ${action} sem contatos associados.`);
      }

      toast.success(
        `Campanha Ativa Whatsapp ${
          isUpdate ? 'atualizada' : 'criada'
        } com sucesso`
      );
      history.push('/admin/chat/broadcast-list');
    } catch (error) {
      console.error('Erro ao criar campanha:', error);
      const errorMessage =
        error?.response?.data?.message ??
        error?.response?.data?.errors?.[0] ??
        'Erro ao criar campanha';
      toast.error(errorMessage);
    }
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  const cancelAction = () => {
    history.push('/admin/chat/broadcast-list');
  };

  /**
   * Callback disparado quando o usuário seleciona (ou desmarca) uma template no Select.
   *
   * @param {TemplateOption|null|undefined} data
   *   Objeto selecionado no react-select ou null/undefined se nenhum estiver marcado.
   */

  /**
   * @typedef {Object} TemplateOption
   * @property {string|number} value
   *   ID da template (usado para buscar os detalhes no backend).
   * @property {string} label
   *   Texto exibido no Select (nome da template).
   */

  /**
   * @typedef {Object} TemplateResponse
   * @property {Object} data
   *   Payload principal retornado pela API (wrapper).
   */

  /**
   * @typedef {Object} TemplatePayload
   * @property {string|number} id
   *   ID único da template.
   * @property {string} name
   *   Nome da template.
   * @property {string} type
   *   Tipo de template (por exemplo, 'TEXT' ou 'MEDIA').
   * @property {string} description
   *   Texto completo, contendo placeholders na forma {{n}}.
   * @property {string?} media
   *   URL ou identificador de mídia (caso exista).
   */

  /**
   * @typedef {Object} SelectedTemplate
   * @property {string}      label
   *   Nome exibido (mesmo que name, mas repetido para o Select).
   * @property {string|number} value
   *   ID da template (igual a tpl.id).
   * @property {string}      templateType
   *   Tipo da template (igual a tpl.type).
   * @property {string}      data
   *   Texto completo (igual a tpl.description).
   * @property {string}      name
   *   Nome da template (igual a tpl.name).
   * @property {string?}     media
   *   Mídia associada (igual a tpl.media), se houver.
   */

  /**
   * @typedef {Object} ParamConfig
   * @property {string} type
   *   Tipo de preenchimento do placeholder (ex: 'TEXT').
   * @property {string} value
   *   Valor a ser exibido ou importado (inicialmente vazio).
   */
  const onChangeSelected = (data) => {
    if (data) {
      clearErrors();
    }
    if (!data) {
      setTemplateParams({});
    }
    setIsLoading(true);
    FlexChatIntegration.getTemplateById(data.value)
      .then((response) => {
        const tpl = response.data.data;
        const description = tpl.description;

        /** @type {SelectedTemplate} */
        setSelectedTemplate({
          label: tpl.name,
          value: tpl.id,
          templateType: tpl.type,
          data: description,
          name: tpl.name,
          media: tpl.media
        });

        const matches = Array.from(description.matchAll(/{{\d+}}/g));
        /** @type {string[]} */
        const renumbered = matches.map((_, i) => `{{${i + 1}}}`);
        setTemplatePlaceholders(renumbered);

        /** @type {{ [placeholder: string]: ParamConfig }} */
        const initialParams = {};
        renumbered.forEach((ph) => {
          initialParams[ph] = { type: 'TEXT', value: '' };
        });
        setTemplateParams(initialParams);
      })
      .catch(() => {
        toast('Ocorreu um erro ao carregar as mensagens predefinidas');
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <>
      <ScreenPrompt
        when={isDirty && !formState.isSubmitting}
        message={`Está certo de que deseja sair? Terá que preencher os dados novamente quando retornar`}
      />
      <SimpleHeader
        name="Form validation"
        parentName="Forms"
        returnPath="/admin/chat/broadcast-list"
        buttonTitle="Voltar para a pagina de campanhas"
      />
      <Container className="mt--6" fluid>
        <Row className="mb-3">
          <div className="col">
            <div className="card-wrapper">
              <Card>
                <CardHeader>
                  <h3 className="mb-0">Campanha Ativa Whatsapp</h3>
                </CardHeader>
                <CardBody>
                  {loading ? (
                    <Row className="justify-content-md-center">
                      <ReactLoader />
                    </Row>
                  ) : (
                    <Form
                      className="needs-validation"
                      onSubmit={handleSubmit(onSubmit)}
                    >
                      <Row className="mb-3">
                        <Col md="4">
                          <label className="form-control-label">Título*</label>
                          <Controller
                            as={Input}
                            control={control}
                            name="title"
                            rules={{ required: 'O título é obrigatório!' }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="title"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="4">
                          <label className="form-control-label">Fila*</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                isClearable={true}
                                dataOptions={queues || []}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                value={props.value}
                                valueController={setValue}
                                fieldName="queueId"
                                labelName="name"
                                valueName="id"
                              />
                            )}
                            control={control}
                            name="queueId"
                            rules={{
                              required: 'Selecione uma fila'
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="queueId"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                        <Col md="4">
                          <label className="form-control-label">
                            Whatsapp*
                          </label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                isClearable={true}
                                dataOptions={whatsappOptions || []}
                                isMulti={false}
                                closeMenuOnSelect={true}
                                value={props.value}
                                valueController={(name, value) => {
                                  setSelectedTemplate(null);
                                  setValue('whatsappTemplateId', '');
                                  setFiles([]);
                                  setValue(name, value);
                                }}
                                fieldName="sourcePhone"
                                labelName="label"
                                valueName="value"
                              />
                            )}
                            control={control}
                            name="sourcePhone"
                            rules={{
                              required: 'Selecione um Whatsapp'
                            }}
                            defaultValue=""
                          />
                          <ErrorMessage
                            errors={errors}
                            name="sourcePhone"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">Tipo*</label>
                          <Controller
                            render={(props) => (
                              <FlexSelect
                                isClearable={true}
                                dataOptions={
                                  broadcastTypeOfClosingConversationOptions
                                }
                                isMulti={false}
                                closeMenuOnSelect={true}
                                value={props.value}
                                valueController={setValue}
                                fieldName="broadcastTypeOfClosingConversation"
                                labelName="label"
                                valueName="value"
                              />
                            )}
                            control={control}
                            name="broadcastTypeOfClosingConversation"
                            defaultValue={
                              broadcastTypeOfClosingConversationOptions[0]
                            }
                          />
                        </Col>

                        {(selectedOption === TRANSFER_TO_FLEXIA ||
                          selectedOption ===
                            TRANSFER_TO_FLEXIA_WITH_PROTOCOL) && (
                          <Col md="6">
                            <label className="form-control-label">
                              FlexIA*
                            </label>
                            <Controller
                              render={() => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={handleFilterFlexiaByType(
                                    flexiaDataAll
                                  )}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={selectedFlexia}
                                  valueController={(name, value) => {
                                    setSelectedFlexia(value);
                                    setValue(name, value);
                                  }}
                                  fieldName="flexiaId"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="flexiaId"
                              rules={{
                                required: 'A FlexIA é obrigatória!'
                              }}
                              defaultValue=""
                            />

                            <ErrorMessage
                              errors={errors}
                              name="idFlexia"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        )}

                        {shouldRenderFlexiaTags && (
                          <TagConversaField
                            tagConversa={tagConversa}
                            setTagConversa={setTagConversa}
                            control={control}
                            setValue={setValue}
                            errors={errors}
                            label="FlexIA Tags"
                          />
                        )}
                      </Row>

                      <Row className="mb-3">
                        <Col md="6">
                          <label className="form-control-label">
                            Templates*
                          </label>
                          <SelectTemplateWrapper>
                            <Select
                              styles={{ ...custom_select, width: '100%' }}
                              placeholder="Selecione..."
                              options={templatesTitle || []}
                              isSearchable={true}
                              isClearable={false}
                              name="whatsappTemplateId"
                              defaultValue=""
                              value={selectedTemplate}
                              filterOption={(option, inputValue) =>
                                SearchTemplateWhatsapp({ inputValue, option })
                              }
                              onChange={(data) => {
                                onChangeSelected(data);
                              }}
                              getOptionLabel={(option) => {
                                return (
                                  <SelectTemplateOptions
                                    isMulti={false}
                                    color={Colors[option.templateType]}
                                    title={option.label}
                                  >
                                    {option.name}
                                    {Icons[option.templateType] ?? '!'}
                                  </SelectTemplateOptions>
                                );
                              }}
                            />
                          </SelectTemplateWrapper>
                          <ErrorMessage
                            errors={errors}
                            name="whatsappTemplateId"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>

                        {selectedOption === CLOSE_ON_FIRST_RESPONSE ? (
                          <Col md="6">
                            <label className="form-control-label">
                              Mensagem De Encerramento*
                            </label>
                            <Controller
                              as={Input}
                              control={control}
                              name="closingMessage"
                              rules={{
                                required: 'A Mensagem é obrigatória!'
                              }}
                              defaultValue=""
                            />
                            <ErrorMessage
                              errors={errors}
                              name="closingMessage"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        ) : (
                          <></>
                        )}

                        {selectedOption !== TRANSFER_TO_QUEUE &&
                          selectedOption !== CLOSE_AFTER_SEND && (
                            <Col md="3">
                              <label className="form-control-label">
                                Data de encerramento*
                              </label>
                              <Controller
                                render={(props) => (
                                  <DatePicker
                                    fieldName="expiryDay"
                                    valueController={(fieldName, value) => {
                                      setValue(fieldName, value);
                                    }}
                                    defaultValue={props.value}
                                  />
                                )}
                                control={control}
                                name="expiryDay"
                                defaultValue={currentDate()}
                              />
                              <ErrorMessage
                                errors={errors}
                                name="expiryDay"
                                render={({ message }) => (
                                  <ErrorFormMessage message={message} />
                                )}
                              />
                            </Col>
                          )}
                        {selectedOption !== TRANSFER_TO_QUEUE &&
                          selectedOption !== CLOSE_AFTER_SEND && (
                            <Col md="3">
                              <FlexController
                                type="time"
                                textoDoLabel="Horário final*"
                                name="expirationTime"
                                {...{
                                  errors,
                                  errorFormMessage,
                                  control,
                                  valueController: setValue
                                }}
                              />
                            </Col>
                          )}
                      </Row>
                      <Row className="mb-3">
                        <Col sm={12}>
                          {!!clientFields &&
                          !!clientFields.length &&
                          !isLoading &&
                          selectedTemplate ? (
                            <>
                              <p className="font-italic font-weight-normal">
                                {selectedTemplate.data}
                              </p>
                              <TemplateMessageFilling
                                templateMessage={selectedTemplate.data}
                                templateParams={templateParams}
                                setTemplateParams={setTemplateParams}
                                setFiles={setFiles}
                                files={files}
                                clientFields={clientFields}
                                isUpdate={isUpdate}
                                templateType={selectedTemplate.templateType}
                                url={
                                  selectedTemplate.media || selectedTemplate.url
                                }
                                templatePlaceholders={templatePlaceholders}
                              />
                            </>
                          ) : isLoading ? (
                            <Col style={{ marginTop: '2rem' }}>
                              <ReactLoader height={60} />
                            </Col>
                          ) : null}
                          <ErrorMessage
                            errors={errors}
                            name="whatsappTemplateParams"
                            render={({ message }) => errorFormMessage(message)}
                          />
                        </Col>
                      </Row>
                      <Row>
                        {selectedOption ===
                          TRANSFER_TO_FLEXIA_WITH_PROTOCOL && (
                          <Col md="6">
                            <label className="form-control-label">
                              Tipo de Registro*
                            </label>
                            <Controller
                              render={(props) => (
                                <FlexSelect
                                  isClearable={true}
                                  dataOptions={recordTypesProtocol || null}
                                  isMulti={false}
                                  closeMenuOnSelect={true}
                                  value={props.value}
                                  valueController={(fieldName, value) =>
                                    setValue(fieldName, value)
                                  }
                                  fieldName="recordTypeId"
                                  labelName="label"
                                  valueName="value"
                                />
                              )}
                              control={control}
                              name="recordTypeId"
                              rules={{
                                required: 'Tipo de registro é obrigatório!'
                              }}
                              defaultValue=""
                            />

                            <ErrorMessage
                              errors={errors}
                              name="recordTypeId"
                              render={({ message }) =>
                                errorFormMessage(message)
                              }
                            />
                          </Col>
                        )}
                      </Row>

                      {(selectedOption === TRANSFER_TO_QUEUE ||
                        selectedOption ===
                          TRANSFER_TO_QUEUE_WITH_FIRST_RESPONSE) && (
                        <>
                          <Row className="ml-0 mt-3">
                            <FlexController
                              type="checkbox"
                              control={control}
                              checked={watch('createLead')}
                              defaultValue={false}
                              valueController={setValue}
                              name="createLead"
                              onChange={(e) => {
                                setValue('createLead', e.target.checked);
                                if (e.target.checked) {
                                  setValue('createOpportunityOnFirstResponse', false);
                                  setValue('opportunityRecordTypeId', '');
                                }
                              }}
                              textoDoLabel="Criar lead com a primeira resposta do cliente"
                            />
                          </Row>

                          {watchCreateLead && (
                            <Row className="ml-0 mt-2">
                              <Col md="6">
                                <label className="form-control-label">
                                  Tipo de Registro (Lead)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      isClearable={true}
                                      dataOptions={leadRecordTypes || []}
                                      isMulti={false}
                                      closeMenuOnSelect={true}
                                      value={props.value}
                                      isLoading={isLoadingLeadRecordTypes}
                                      valueController={(fieldName, value) =>
                                        setValue(fieldName, value)
                                      }
                                      fieldName="leadRecordTypeId"
                                      labelName="name"
                                      valueName="id"
                                      isDisabled={
                                        isLoadingLeadRecordTypes ||
                                        !(leadRecordTypes || []).length
                                      }
                                    />
                                  )}
                                  control={control}
                                  name="leadRecordTypeId"
                                  defaultValue=""
                                />
                                {!isLoadingLeadRecordTypes &&
                                  !(leadRecordTypes || []).length && (
                                    <small className="text-muted">
                                      Nenhum tipo de registro disponível para
                                      Lead.
                                    </small>
                                  )}
                              </Col>
                            </Row>
                          )}

                          <Row className="ml-0">
                            <FlexController
                              type="checkbox"
                              control={control}
                              checked={watch(
                                'createOpportunityOnFirstResponse'
                              )}
                              defaultValue={false}
                              valueController={setValue}
                              name="createOpportunityOnFirstResponse"
                              onChange={(e) => {
                                setValue(
                                  'createOpportunityOnFirstResponse',
                                  e.target.checked
                                );
                                if (e.target.checked) {
                                  setValue('createLead', false);
                                  setValue('leadRecordTypeId', '');
                                }
                              }}
                              textoDoLabel="Criar oportunidade com a primeira resposta do cliente"
                            />
                          </Row>

                          {watchCreateOpportunity && (
                            <Row className="ml-0 mt-2">
                              <Col md="6">
                                <label className="form-control-label">
                                  Tipo de Registro (Oportunidade)*
                                </label>
                                <Controller
                                  render={(props) => (
                                    <FlexSelect
                                      isClearable={true}
                                      dataOptions={opportunityRecordTypes || []}
                                      isMulti={false}
                                      closeMenuOnSelect={true}
                                      value={props.value}
                                      isLoading={
                                        isLoadingOpportunityRecordTypes
                                      }
                                      valueController={(fieldName, value) =>
                                        setValue(fieldName, value)
                                      }
                                      fieldName="opportunityRecordTypeId"
                                      labelName="name"
                                      valueName="id"
                                      isDisabled={
                                        isLoadingOpportunityRecordTypes ||
                                        !(opportunityRecordTypes || []).length
                                      }
                                    />
                                  )}
                                  control={control}
                                  name="opportunityRecordTypeId"
                                  defaultValue=""
                                />
                                {!isLoadingOpportunityRecordTypes &&
                                  !(opportunityRecordTypes || []).length && (
                                    <small className="text-muted">
                                      Nenhum tipo de registro disponível para
                                      Oportunidade.
                                    </small>
                                  )}
                              </Col>
                            </Row>
                          )}
                        </>
                      )}

                      <BroadcastSchedulingFields
                        {...{
                          control,
                          isEnabledSchedule,
                          setValue,
                          setIsEnabledSchedule,
                          errors,
                          currentDate,
                          hourRules
                        }}
                      />
                      <hr />
                      {selectedOption === TRANSFER_TO_FLEXIA_WITH_PROTOCOL &&
                        selectedRecordType && (
                          //Area de campos do protocolo
                          <ProtocolFieldsBroadcastList
                            setValue={setValue}
                            control={control}
                            errors={errors}
                            selectedOption={selectedOption}
                            selectedRecordType={selectedRecordType}
                            watch={watch}
                            getValues={getValues}
                            isUpdate={isUpdate}
                          />
                        )}

                      <ReactButton btnColor="confirmation" type="submit">
                        Salvar
                      </ReactButton>

                      <ReactButton
                        btnColor="cancelation"
                        onClick={() => cancelAction()}
                      >
                        Cancelar
                      </ReactButton>
                    </Form>
                  )}
                </CardBody>
              </Card>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};
